/**
 * Character key codes which can be used in keyboard events.
 */
export var KEY_UP = 'ArrowUp';
export var KEY_DOWN = 'ArrowDown';
export var KEY_HOME = 'Home';
export var KEY_END = 'End';
export var ESCAPE = 'Escape';